import envConfig from '@/config/env';
import { IResponse } from '@/request/request.interface';
import { IChainCoin } from '@/request/token/token.response.interface';
import { useAppStore } from '@/store';
import { useEffect, useCallback } from 'react';

export const useChainCoinPrice = (loop = false, interval = 30000) => {
  const { setChainCoinPrice, chainInfo } = useAppStore();

  const getChainCoinPrice = useCallback(async () => {
    try {
      const res: IResponse<IChainCoin[]> = await fetch(envConfig.VITE_API_BUSINESS_URL + '/blockchain/payment-token').then((res) => res.json());
      if (res.code == 0) {
        res.data.forEach((item) => {
          if (item.chainId === chainInfo.chainId) {
            setChainCoinPrice(item.price);
          }
        });
      }
    } catch (err) {
      console.error('Failed to fetch Chain price');
    }
  }, [chainInfo]);

  useEffect(() => {
    getChainCoinPrice();

    if (loop) {
      const timer = setInterval(getChainCoinPrice, interval);

      return () => {
        clearInterval(timer);
      };
    }
    return () => {};
  }, [loop, interval]);

  return { getChainCoinPrice };
};
